import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(8, 6),
      borderRadius: 32,

      backgroundColor: COLORS.neutral.silver,
    },
    header: {
      fontWeight: theme.typography.fontWeightBold,
      color: COLORS.gray.black,
      marginBottom: theme.spacing(3),
      textAlign: 'center',
    },
    cards: {
      display: 'flex',
      columnGap: theme.spacing(3),
    },
    oneCard: {
      justifyContent: 'center',
    },
    card: {
      cursor: 'pointer',
      width: 420,
      height: 323,
      padding: theme.spacing(4, 3.75),
      border: theme.shape.borderGray60,
      borderRadius: 12,
      backgroundColor: COLORS.neutral.white,
      '&:hover': {
        borderColor: COLORS.primary.default,
      },
    },
    title: {
      color: COLORS.primary.default,
      textAlign: 'center',
    },
    subtitle: {
      color: COLORS.gray.black,
      margin: theme.spacing(0.5, 0, 3),
      textAlign: 'center',
    },
  }),
  { name: 'AccountsDataExtractionNavigationPopup' }
);
